import { z } from 'zod';

export const documentManagementSchema = z.object({
  view: z.union([z.literal('self'), z.literal('anyone')]),
  upload: z.union([z.literal('self'), z.literal('anyone'), z.literal('none')]),
  deletion: z.union([z.literal('self'), z.literal('anyone'), z.literal('none')]),
  approve: z.boolean().optional(),
  mark_as_paid: z.boolean().optional(),
  profiles_to_notify_on_upload: z.array(z.string()).optional(),
});

type documentManagementSchemaType = z.infer<typeof documentManagementSchema>;

const defaultValue: documentManagementSchemaType = {
  view: 'self',
  upload: 'self',
  deletion: 'self',
  approve: false,
  mark_as_paid: false,
  profiles_to_notify_on_upload: [],
};

export const documentManagementDefaultValue = JSON.stringify(defaultValue, null, '\t');
